module.exports = __webpack_public_path__ + "img/Global_Compact_Environment.f16f424b.svg";